<template>
  <div class="container-fluid">
    <div class="row align-items-center pt-4">
      <div class="col-sm-7 text-center order-md-last">
        <img src="../assets/img/home1.svg" class="img-fluid home-image" />
      </div>
      <div class="col-sm-5 text-center text-md-left home01">
        <div class="div-size">
          <h1 class="heading">FASDO</h1>
          <h5 class="home-p-head pb-2">
            Order Your Grocery & Daily Use
            Products Hassle Free , Easily
            From Fasdo
          </h5>
          <hr class="home-hr float-left d-none d-md-block" />
          <br />
          <p class="home-p-body">
            With Fasdo you can get your products
            at your doorstep in less time
          </p>
          <a :href="appLink" target="_blank">
            <img
              src="../assets/img/googlePlay.png"
              class="img-fluid home-download-button"
              @click="click()"
            />
          </a>
        </div>
      </div>
    </div>
    <hr />
    <!-- home 0 -->
    <div class="row align-items-center p-4">
      <div class="col-sm-12 text-center">
        <h2 class="home0">Shopping made Simple with Fasdo</h2>
      </div>
    </div>
    <!-- home 2 -->
    <div class="row align-items-center justify-content-center pt-4 pb-4">
      <div class="col-sm-6 text-center">
        <img src="../assets/img/home2.png" class="img-fluid home-image" />
      </div>
      <div class="col-sm-6 text-center text-md-left home02">
        <div class="div-size">
          <h3 class="home-p-head">Save your time, Shop online</h3>
          <p class="home-p-body">
            Don't have time to go to shop or you don't have
            a shop near you. Just order from Fasdo and
            we will take care of everything.
          </p>
        </div>
      </div>
    </div>
    <!-- home 3 -->
    <div class="row align-items-center justify-content-center pt-4 pb-4">
      <div class="col-sm-6 text-center order-md-last">
        <img src="../assets/img/home3.png" class="img-fluid home-image" />
      </div>
      <div class="col-sm-6 text-center text-md-left home04">
        <div class="div-size">
          <h3 class="home-p-head">Easy Returns & Refunds</h3>
          <hr class="home-hr float-left d-none d-md-block" />
          <br />
          <p class="home-p-body">
            Not satisfied with our products. Simply
            return the product and we won't even
            ask any question. We give instant
            refunds, no waiting to get your
            money back.
          </p>
        </div>
      </div>
    </div>
    <!-- home 4 -->
    <div class="row align-items-center justify-content-center pt-4 pb-4">
      <div class="col-sm-6 text-center">
        <img src="../assets/img/home4.png" class="img-fluid home-image" />
      </div>
      <div class="col-sm-6 text-center text-md-left home04">
        <div class="div-size">
          <h3 class="home-p-head">Don't have internet. Its not a problem</h3>
          <hr class="home-hr float-left d-none d-md-block" />
          <br />
          <p class="home-p-body">
            Order directly from WhatsApp and get
            your product at your doorstep quick and
            easy.
          </p>
        </div>
      </div>
    </div>
    <!-- home 5 -->
    <div class="row jumbotron align-items-center justify-content-center home5">
      <div class="col-sm-12 container text-center">
        <h5>Get Started its quick and easy</h5>
        <div class="row align-items-center justify-content-center process p-4">
          <div class="col-sm-auto text-center">
            <img src="../assets/img/icons/download-circle.png" class="img-fluid pb-2" />
            <br />
            <small class="f-theme-color font-weight-bold">DOWNLOAD FASDO</small>
          </div>
          <div class="col-sm-auto text-center">
            <hr />
          </div>
          <div class="col-sm-auto text-center">
            <img src="../assets/img/icons/register-circle.png" class="img-fluid pb-2" />
            <br />
            <small class="f-theme-color font-weight-bold">REGISTER YOUR NUMBER</small>
          </div>
          <div class="col-sm-auto text-center">
            <hr />
          </div>
          <div class="col-sm-auto text-center">
            <img src="../assets/img/icons/smile.png" class="img-fluid pb-2" />
            <br />
            <small class="f-theme-color font-weight-bold">START SHOPPING</small>
          </div>
        </div>
        <a :href="appLink" target="_blank">
          <img
            src="../assets/img/googlePlay.png"
            class="img-fluid home-download-button"
            @click="click()"
          />
        </a>
      </div>
    </div>
    <!-- fixed download button -->
    <div class="row d-sm-block d-md-none">
      <div class="col-sm-1"></div>
      <div class="col-sm-10">
        <a :href="appLink" target="_blank" class="btn btn-download" @click="click()">DOWNLOAD FASDO</a>
      </div>
      <div class="col-sm-1"></div>
    </div>
  </div>
</template>

<script>
import { appLinkPlayStore } from "@/store/variable";
export default {
  name: "landingPage",
  data() {
    return {
      appLink: appLinkPlayStore
    };
  },

  methods: {
    click() {
      this.$ga.event({
        eventCategory: "DownloadButton",
        eventAction: "Pressed",
        eventValue: 1
      });
    }
  }
};
</script>

<style scoped>
.div-size {
  max-width: 35em;
}

.home-image {
  padding-bottom: 2em;
  height: 32em;
  width: auto;
}

.home-icon {
  border-radius: 50%;
  padding: 0.5em;
  background: #ffffff;
}

.home-download-button {
  width: 18em;
}

.home0 {
  font-weight: 400;
}

.home01 div .heading {
  color: #ee5214;
  font-weight: 800;
  text-transform: uppercase;
}

/* .home01-image {
  height: 32em;
} */

.home-p-head {
  font-weight: 600;
  line-height: 1.75;
}

.home-p-body {
  font-weight: 400;
  font-size: large;
  line-height: 1.75;
}

.home-hr {
  width: 8em;
  border-bottom: 4px solid #ee5214;
  margin: 0;
  padding: 0;
}

.home4 .home-hr {
  width: 8em;
}

.home5 {
  background: #f8f8f8;
}

.home5 hr {
  width: 13em;
  border: 1px #707070 solid;
}

.home5 h5 {
  font-weight: 500;
}

.home5 .process img {
  width: 9em;
}

.home5 img {
  width: 16em;
}

@media only screen and (max-width: 600px) {
  .home-image {
    height: 28em;
    width: auto;
  }

  .home01-image {
    height: 24em;
  }

  .home5 .process img {
    width: 6em;
  }

  .home5 hr {
    display: block;
    width: 0;
    height: 7em;
    border-left: 1px #707070 solid;
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing.vue